function customTypeof(value) {
  if (Array.isArray(value)) {
    return "array";
  } else if (Number.isNaN(value)) {
    return "nan";
  } else {
    return typeof value;
  }
}

const cutBranchNo = (input) => {
  let type = customTypeof(input);
  let res = "";

  const cutLength = 4;
  switch (type) {
    case "string":
      res = input.substring(cutLength);
      break;
    case "number":
      let inputInt = input.toString();
      res = inputInt.substring(cutLength);
      break;
    default:
      res = "";
      break;
  }
  return res;
};

export default cutBranchNo;
